var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClassName||'w-full'},[(_vm.content)?_c('div',{class:_vm.className},[_vm._v(_vm._s(_vm.content))]):_c('div',{staticClass:"content-none my-3",class:_vm.noContentClass||'w-full'})])
}
var staticRenderFns = []

export { render, staticRenderFns }